/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/


import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import regulation from "assets/pdfs/regulation.pdf";


function Regulation() {
  // const passwordRequirements = [
  //   "One special characters",
  //   "Min 6 characters",
  //   "One number (2 are recommended)",
  //   "Change it often",
  // ];

  // const renderPasswordRequirements = passwordRequirements.map((item, key) => {
  //   const itemKey = `element-${key}`;

  //   return (
  //     <MDBox key={itemKey} component="li" color="text" fontSize="1.25rem" lineHeight={1}>
  //       <MDTypography variant="button" color="text" fontWeight="regular" verticalAlign="middle">
  //         {item}
  //       </MDTypography>
  //     </MDBox>
  //   );
  // });
  const [visible, setVisible] = useState(true);
  const handleSetVisible = () => setVisible(!visible);

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  return (
    <Card id="regulation">
      <MDBox p={3}>
        <Grid item style={{display: "inline"}}>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDTypography variant="p" fontWeight="medium">
                Regulation:
              </MDTypography>
            </MDBox>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDButton style={{"margin" : "15px" }} variant="outlined" color="success">
                Download
              </MDButton>
            </MDBox>
          </Grid>
      </MDBox>

      <MDBox p={2}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={12} lg={12} sx={{ ml: "auto" }}>
            <MDBox
              display="flex"
              justifyContent={{ md: "center" }}
              alignItems="center"
              lineHeight={1}
            >
              <Document
                file={regulation}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                <Page pageNumber={pageNumber} />
              </Document>
            </MDBox>
          </Grid>

          <Grid item xs={12} md={12} lg={12} sx={{ ml: "auto" }}>
            <MDBox
              display="flex"
              justifyContent={{ md: "flex-end" }}
              alignItems="center"
              lineHeight={1}
            >
              <div>
                <MDBox height="85%" mt={0.5} lineHeight={1}>
                  <MDTypography variant="p" fontWeight="light">
                    Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
                  </MDTypography>
                </MDBox>
                <MDButton
                  type="button"
                  disabled={pageNumber <= 1}
                  onClick={previousPage}
                >
                  Previous
                </MDButton>
                <MDButton
                  type="button"
                  disabled={pageNumber >= numPages}
                  onClick={nextPage}
                >
                  Next
                </MDButton>
              </div>
            </MDBox>
          </Grid>
          

          <Grid item>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDTypography variant="p" fontWeight="medium">
                Link to Regulation:
              </MDTypography>
            </MDBox>
            <MDBox height="85%" mt={0.5} lineHeight={1}>
              <MDTypography variant="p" fontWeight="light">
                https://www.regulations.gov/document/USCIS-2015-0006-0655
                {/* https://www.uscis.gov/sites/default/files/document/forms/i-941.pdf */}
              </MDTypography>
            </MDBox>
          </Grid>

        </Grid>
      </MDBox>
    </Card>
  );
}

export default Regulation;
